import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Icon } from "@/components/Icon";

const TITLE = "Funcții — Asistent Auto";
const DESCRIPTION =
  "Reminder-uri inteligente, hub multi-mașină, comparare oferte RCA, OCR talon, arhivă PDF — toate funcțiile Asistent Auto într-un singur loc.";

const tiles = [
  {
    span: 6,
    icon: "schedule",
    title: "Reminder la timp, nu în ultima clipă",
    body: "Aceeași cadență pentru orice tip de document: 30 de zile, 7 zile și ziua dinainte. Push sau email — tu alegi canalul.",
  },
  {
    span: 6,
    icon: "document_scanner",
    title: "OCR talon care chiar funcționează",
    body: "Camera face poză talonului — 14 câmpuri se completează automat. Marca, modelul, capacitatea, anul. Verifici și salvezi.",
  },
  {
    span: 4,
    icon: "compare_arrows",
    title: "8 oferte RCA",
    body: "Comparare în timp real cu Asirom, Hellas, Omniasig, Groupama, Grawe, Allianz Țiriac, Eazy și Generali — prin Inter Broker.",
  },
  {
    span: 4,
    icon: "groups",
    title: "Hub multi-mașină",
    body: "Adaugi mașinile partenerului, părinților, ale flotei. Fiecare cu ownerul ei.",
  },
  {
    span: 4,
    icon: "folder_zip",
    title: "Arhivă PDF",
    body: "Toate polițele și procesele verbale, organizate per mașină. Caută și descarcă.",
  },
  {
    span: 6,
    icon: "home_work",
    title: "Și pentru casă, călătorii, malpractice",
    body: "Aceleași grupuri de câmpuri, aceleași reminder-uri. Locuință, asigurare medicală de călătorie, malpractice — totul în același cont.",
  },
  {
    span: 6,
    icon: "lock",
    title: "Datele tale, în siguranță",
    body: "Infrastructură Google Cloud. Criptare AES-256 la depozitare. Token-uri biometrice pentru autentificare. Zero share-uri cu terți.",
  },
] as const;

export default function FunctiiPage() {
  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path="/functii" />
      <header className="page-hero">
        <div className="shell">
          <div className="section-eyebrow">Funcții</div>
          <h1>
            Tot ce face <em>asistentul tău,</em> pe scurt.
          </h1>
          <p>
            Trei părți principale — reminder-uri inteligente, hub multi-mașină,
            comparare oferte — plus o sută de detalii mici care fac diferența la
            ora 9 dimineața când plouă.
          </p>
        </div>
      </header>

      <section className="section section--tight">
        <div className="shell">
          <div className="bento">
            {tiles.map((t) => (
              <div key={t.title} className={`tile span-${t.span}`}>
                <div className="icon-box">
                  <Icon name={t.icon} />
                </div>
                <h3>{t.title}</h3>
                <p>{t.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <div className="cta-strip">
            <div style={{ position: "relative", zIndex: 1 }}>
              <h2>
                Vezi-l live. <em>Durează un minut.</em>
              </h2>
              <p>
                Descarci aplicația, adaugi o mașină cu OCR. Dacă nu te convingi
                în 60 de secunde, ștergi. Promitem.
              </p>
              <Link
                to="/#download"
                className="btn btn--ghost-light btn--lg"
              >
                <Icon name="download" />
                Descarcă acum
              </Link>
            </div>
            <div />
          </div>
        </div>
      </section>
    </>
  );
}
